import { lsT, SHAPES, leakAreaM2 } from '../lib/leakShape';

const show = (v) => String(v ?? '').replace('.', ',');
// one leak definition: round hole / longitudinal crack / circumferential crack (pressure-dependent) or a fixed leak flow
export function LeakFields({ o, set, d = 150, pre = 'lab' }) {
  const x = lsT(), s = o.shape || 'round';
  const inp = (k, l, u) => <label key={k}><span>{l}</span><span className="lab-iu"><input type="text" inputMode="decimal" data-testid={`${pre}-leak-${k}`} value={show(o[k])} onChange={(e) => set(k, e.target.value.replace(/[^\d.,]/g, '').replace(',', '.'))} /> {u}</span></label>;
  return (
    <div className="leak-fields" data-testid={`${pre}-leak-fields`}>
      <b className="aq-sub">{x.kind}</b>
      <div className="chip-group">{SHAPES.map((k) => <button key={k} type="button" className={`chip seg ${s === k ? 'on' : ''}`} data-testid={`${pre}-leak-shape-${k}`} onClick={() => set('shape', k)}>{x[k]}</button>)}</div>
      <div className="aq-grid">
        {s === 'round' && inp('hole', x.d, 'mm')}
        {s === 'long' && [inp('cl', x.len, 'mm'), inp('cw', x.w, 'mm')]}
        {s === 'circ' && [inp('cw', x.w, 'mm'), inp('cf', x.frac, '%')]}
        {s === 'qty' && inp('lq', x.q, 'l/s')}
      </div>
      <small className="muted" data-testid={`${pre}-leak-info`}>{s === 'qty' ? x.qHint : x.area.replace('{a}', (leakAreaM2(o, d) * 1e6).toFixed(1).replace('.', ','))}</small>
    </div>
  );
}
